importScripts('https://storage.googleapis.com/workbox-cdn/releases/4.3.1/workbox-sw.js');

if (workbox) {
  console.log(`Workbox is loaded`);
} else {
  console.log(`Workbox didn't load`);
}

workbox.routing.registerRoute(
  /\baries\b.*\/(?:mi-accordion|mi-carousel|mi-foundation|mi-header|mi-lazy-load-images|mi-picturefill|mi-slider|mi-ss|adaptiveDestinationCarousel|adaptiveHeading|articleContentText|articleLinksGroup|cardText|clickToAction|dataLayer|hdVars|heroImageITO|linksBlock|logosPortfolio|mainNavLink|marketingTiles|marriottRewardsMemberRates|messageResource|metaHtmlHead|mi-common|mi-vendor|mi-core|pageStaticContent|paysBookDirect|programLogo|quickLinkItem|searchFormHorizontalHomePage|sessionTimeOut|signIn|transactionalFooterLinks|univNavHamburgerMenu|viewAllOffer|myTrips|nightDetails|userProfileSummary|rewardsHubSubNav|myReservation|searchResultsFreeNights|unsuccessfulSellOverlay|propertyRecordsSearchToolBar|searchFilters|myAccount|searchFormHorizontalFindHotels|searchSummar|hdVars|dataLayer|articleLinksGroup|suggestedFilters|phoneReservations|onePixelLine|adaptiveHtmlHead|accountMergeMessage|nightDetails|propertyRecords|keywordSearch|summaryOfCharges|globalPrivacyConsent|verisignSeal|reservationStep|userInformationForm|visaCheckout|smsNotification|travelAgentAndPlannerForm|addressInfo|signInLink|rewardsAd|optionWidget|confirmationDetails|hertzAd|adaraAds|memberOptions|planYourStayHeader|paysBookDirect|certificateStatus|ersRateListMenu|memberDetails|submissionMessages|errorMessages|applySuiteNightAwards|confirmationInfoMessages)\.js/,
  new workbox.strategies.CacheFirst({
    cacheName: 'js-cache',
    plugins: [
      new workbox.cacheableResponse.Plugin({
        statuses: [0, 200]
      }),
      new workbox.expiration.Plugin({
        // Cache for a maximum of 7 days.
        maxAgeSeconds: 7 * 24 * 60 * 60,
      })
    ]
  })
);

workbox.routing.registerRoute(
  // Cache CSS files.
  /\baries\b.*\/(?:brands|foundation|adaptiveDestinationCarousel|adaptiveHeading|articleContentText|articleLinksGroup|cardText|clickToAction|dataLayer|hdVars|heroImageITO|linksBlock|logosPortfolio|mainNavLink|marketingTiles|marriottRewardsMemberRates|messageResource|metaHtmlHead|pageStaticContent|paysBookDirect|programLogo|quickLinkItem|searchFormHorizontalHomePage|sessionTimeOut|signIn|transactionalFooterLinks|univNavHamburgerMenu|viewAllOffer|rewardsHubSubNav|adaptiveHtmlHead|dataLayer|hdVars|mainNavLink|searchFilter|searchResultsFreeNights|propertyRecordsSearchToolBar|messageConten|propertyRecords|myAccount|searchSummary|unsuccessfulSellOverlay|suggestedFilters|searchFormHorizontalFindHotels|brands_cy|accountMergeMessage|nightDetails|rewardsHubSubNav|unsuccessfulSellOverlay|signOutLink|submissionMessages|recentlyViewedProperty|otherSearchOptions|phoneReservation|keywordSearch|yourRequest|reservationDetails|redemptionOptions|hotelHeader|summaryOfCharges|reservationSummary|globalPrivacyConsent|bookNow|reservationStep|joinNowOptions|rewardsLogo|travelAgentAndPlannerForm|smsNotification|userInformationForm|visaCheckout|rewardsAd|adaraAds|memberOptions|bookingOffer|rwdMobileAppDownload|paysBookDirect|optionWidget|confirmationDetail|planYourStayHeader|cancellationPolicy|roomPreferences|certificateStatus|ersRateListMenu|errorMessages|applySuiteNightAwards)\.css/,
  new workbox.strategies.CacheFirst({
    // Use a custom cache name.
    cacheName: 'css-cache',
    plugins: [
      new workbox.cacheableResponse.Plugin({
        statuses: [0, 200]
      }),
      new workbox.expiration.Plugin({
        // Cache for a maximum of 7 days.
        maxAgeSeconds: 7 * 24 * 60 * 60,
      })
    ]
  })
);

workbox.routing.registerRoute(
  /https\:\/\/cache.marriott.com.*\/(?:Swiss721BT-BlackCondensed|Swiss721BT-BoldCondensed|proxima-nova-bold|proxima-nova-semibold|AvenirNextLTPro-Thin)\.(?:ttf|woff)/,
  new workbox.strategies.CacheFirst({
    cacheName: 'marriott-fonts-cache',
    plugins: [
      new workbox.cacheableResponse.Plugin({
        statuses: [0, 200]
      }),
      new workbox.expiration.Plugin({
        // Cache for a maximum of 7 days.
        maxAgeSeconds: 7 * 24 * 60 * 60,
      })
    ]
  })
);

workbox.routing.registerRoute(
  /\baries\b.*\bstandards\b.*\/(?:brand-logo-icons|portfolio-logo-icons|proxima-nova-regular|profile-icons|video-icons)\.(?:ttf|woff)/,
  new workbox.strategies.CacheFirst({
    cacheName: 'fonts-cache',
    plugins: [
      new workbox.cacheableResponse.Plugin({
        statuses: [0, 200]
      }),
      new workbox.expiration.Plugin({
        // Cache for a maximum of 7 days.
        maxAgeSeconds: 7 * 24 * 60 * 60,
      })
    ]
  })
);